module.exports = __webpack_public_path__ + "media/images/icons/icon-feature-logs-e24cba8fb40575e071594b4451e00e24.svg";